var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomWithdraw = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30h30V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBAC7",
    d: "M17.083 15.945H3.003V2h14.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M14.523 13.41h-8.96V2h8.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.043 5.803c-1.768 0-3.2-1.419-3.2-3.17 0-.217.022-.429.064-.634h6.272c.042.205.064.417.064.635 0 1.75-1.433 3.17-3.2 3.17z",
    fill: "#8CBAC7"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.69 19.955 1.615 1.491a.938.938 0 0 1 .046 1.345l-5.17 5.491a.96.96 0 0 1-1.358.049l-1.615-1.492 6.481-6.884z",
    fill: "#493B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.338 26.485c-1.803-1.557-2.982-2.535-3.535-2.934-2.48-1.788-3.28-2.017-3.84-2.535-1.722-1.59-3.19-3.28-4.4-5.07h7.682l1.278 1.18c.38.351 1 .35 1.386-.027.418-.411.408-1.058.011-1.424l-4.333-4.002c-.877-.81-1.027-2.16-.341-3.185.16-.235.335-.455.544-.676.385-.41 1.005-.443 1.402-.077l2.381 2.2c.778.718 1.859 1.047 3.022 1.388 1.212.355 2.458.74 3.514 1.588a9.656 9.656 0 0 1 2.34 2.703c.653 1.113.528 2.56-.304 3.608l.016.016-6.823 7.247z",
    fill: "#F2AE18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.003 5h2V2.5h14V5h2V2h-18v3z",
    fill: "#1B7690"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomWithdraw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-withdraw.9f05a870f6a0a07ff6c70623fc3d87b7.svg";